import React, {useContext, useEffect, useReducer} from 'react'
import { EventContext } from './EventContext'
import { EVENT_ACTION } from '../../constant'

const initialState = {
	article_id: null
}
const eventReducer = (state, action) => {
	switch (action.type){
		case EVENT_ACTION.SET_EVENT: {
			return {
				...state,
				...action.payload
			}
		}
		default: {
			return state
		}
	}
}

export function EventProvider({children}){
	const [event, dispatch] = useReducer(eventReducer, initialState)

	return <EventContext.Provider value={{
		event,
		setEvent: (params) => dispatch({type: EVENT_ACTION.SET_EVENT, payload: params}),
	}}>{children}</EventContext.Provider>
}